import { render, staticRenderFns } from "./Helpitem.vue?vue&type=template&id=3883f104&"
import script from "./Helpitem.vue?vue&type=script&lang=js&"
export * from "./Helpitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports